import styled from 'styled-components'
import measures from 'globals/measures'

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 7px;
`

export const FormLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  
  @media (max-width: ${measures.mobileThreshold}px) {
    flex-wrap: wrap;
  }
`

interface FieldProps {
  columns: number,
  mobileColumns: number
}

const flexBasisFromColumns = (columns: number) => {
  if (columns <= 1) {
    return '33%'
  } else if (columns === 2) {
    return '68%'
  } else {
    return '100%'
  }
}

const flexBasisFromMobileColumns = (columns: number) => {
  if (columns <= 1) {
    return '45%'
  } else {
    return '100%'
  }
}

export const FormField = styled.div<FieldProps>`
  margin-right: 10px;
  margin-bottom: 10px;
  flex-basis: ${(props) => flexBasisFromColumns(props.columns)};
  
  &:last-child {
    margin-right: 0;
  }
  
  @media (max-width: ${measures.mobileThreshold}px) {
    flex: 1;
    flex-basis: ${(props) => flexBasisFromMobileColumns(props.mobileColumns)};
    
    ${(props) => props.mobileColumns > 1 && `
      margin-right: 0;
    `};
    
    ${(props) => props.mobileColumns <= 1 && `
      &:nth-child(2n) {
        margin-right: 0;
      }
    `};
  }
`
